<template>
  <div class="warp">
    <div class="header">
      <van-nav-bar
          title="编辑笔记"
          right-text="删除"
          left-arrow fixed
          @click-left="goBack"
          @click-right="onClickRight"
      />
    </div>

    <div class="bodyWarp">
      <div>
        <van-field
            v-model="detail.content"
            rows="10"
            type="textarea"
            maxlength="1000"
            placeholder="请输入内容"
            show-word-limit
            :autosize="{maxHeight:500}"
        />
      </div>

      <div class="btn" @click="save">保存</div>
    </div>

  </div>
</template>

<script>
import {editNote, deleteNote} from "@/api/study_course.js";
export default {
  data() {
    return {
      detail: {}
    }
  },
  name: 'noteDetail',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onClickRight() {
      deleteNote({noteId:this.detail.id}).then((res) => {
        if(res.data.code === 0) {
          this.goBack();
        }
      });
    },
    save() {
      let params = {
        id: this.detail.id,
        content: this.detail.content
      };
      editNote(params).then((res) => {
        if(res.data.code === 0) {
          this.goBack();
        }
      });
    }
  },
  created() {
    this.detail = JSON.parse(window.localStorage.getItem('noteDetail'));
  }
}
</script>

<style lang="less" scoped>
.header {
  font-size: 17px;
  font-weight: 500;
  color: #141414;
  line-height: 24px;
}

/deep/ .van-nav-bar__title {
  font-size: 17px;
  font-weight: 500;
  color: #141414;
}

/deep/ .header .van-icon-arrow-left {
  color: #000;
}

.bodyWarp {
  margin-top: 42px;
  height: calc(100vh - 76px);
  overflow: auto;
  background: #F8F8F8;
  padding: 15px;

  .btn{
    width: 100%;
    margin: 22px auto;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #5F7DFF;
    border-radius: 5px;
    color: #fff;
  }
}

</style>
